/* eslint-disable @typescript-eslint/no-explicit-any */
function randomNumber() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default randomNumber;
//# sourceMappingURL=random-number.esm.js.map
